import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';

console.log('Starting app...');

const container = document.getElementById('root');
console.log('Root element:', container);

if (!container) {
  throw new Error('Failed to find the root element');
}

const root = createRoot(container);

try {
  console.log('Rendering app...');
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
  console.log('App rendered successfully');
} catch (error) {
  console.error('Error rendering app:', error);
  
  // Fallback rendering without StrictMode
  root.render(<App />);
}
